export default [
  {
    path: "entertainmentPlace",
    name: "entertainmentPlace",
    component: () =>
      import(
        "@/views/industryControl/entertainmentPlace/entertainmentPlace.vue"
      ),
    meta: {
      title: "娱乐场所"
    }
  },
  {
    path: "specialIndustry",
    name: "specialIndustry",
    component: () =>
      import("@/views/industryControl/specialIndustry/specialIndustry.vue"),
    meta: {
      title: "特种行业"
    }
  },
  {
    path: "analysisAndJudgment",
    name: "analysisAndJudgment",
    component: () =>
      import(
        "@/views/industryControl/analysisAndJudgment/analysisAndJudgment.vue"
      ),
    meta: {
      title: "信息查询及分析研判"
    }
  },
  {
    path: "elementCollection",
    name: "elementCollection",
    component: () =>
      import("@/views/industryControl/elementCollection/elementCollection.vue"),
    meta: {
      title: "要素采集"
    }
  }
];
